import { useCallback, RefObject } from 'react';
import { BodyScrollEvent, GridApi } from 'ag-grid-community';

interface UseInfiniteScrollHandlerProperties {
  fetchNextPage: () => void;
  gridApiReference: RefObject<GridApi | null>;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
}

export const useInfiniteScrollHandler = ({
  hasNextPage,
  isFetchingNextPage,
  fetchNextPage,
  gridApiReference,
}: UseInfiniteScrollHandlerProperties) => {
  const onBodyScroll = useCallback(
    (_event: BodyScrollEvent) => {
      const canFetchMore =
        hasNextPage && !isFetchingNextPage && gridApiReference.current;

      if (!canFetchMore) {
        return;
      }

      const verticalScrollbar = document.querySelector(
        '.ag-body-vertical-scroll-viewport'
      );

      if (!verticalScrollbar) {
        return;
      }

      const scrollTop = verticalScrollbar.scrollTop;
      const scrollHeight = verticalScrollbar.scrollHeight;
      const clientHeight = verticalScrollbar.clientHeight;

      const scrollThreshold = 0.999;
      const isNearBottom =
        scrollTop + clientHeight >= scrollHeight * scrollThreshold;

      if (isNearBottom) {
        fetchNextPage();
      }
    },
    [hasNextPage, isFetchingNextPage, fetchNextPage, gridApiReference]
  );

  return { onBodyScroll };
};
